import { render, staticRenderFns } from "./JeecgDemoTabsModal.vue?vue&type=template&id=1304afe1&scoped=true&"
import script from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
export * from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgDemoTabsModal.vue?vue&type=style&index=0&id=1304afe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304afe1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1304afe1')) {
      api.createRecord('1304afe1', component.options)
    } else {
      api.reload('1304afe1', component.options)
    }
    module.hot.accept("./JeecgDemoTabsModal.vue?vue&type=template&id=1304afe1&scoped=true&", function () {
      api.rerender('1304afe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/JeecgDemoTabsModal.vue"
export default component.exports